import React from "react";
import { motion } from "framer-motion";

// Logo Spinner Loader
export const LogoSpinnerLoader = ({ logoSrc = "/your-logo.svg" }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <div className="relative w-24 h-24 mb-6">
        <motion.div
          className="absolute inset-0"
          animate={{ rotate: 360 }}
          transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
        >
          <div className="w-full h-full rounded-full border-4 border-t-4 border-t-green-500 border-blue-500 opacity-75"></div>
        </motion.div>
        <div className="absolute inset-0 flex items-center justify-center">
          <img src={logoSrc} alt="Site Logo" className="w-16 h-16" />
        </div>
      </div>
      <p className="text-white text-lg font-medium">Loading game...</p>
    </div>
  );
};

// Pulsing Logo Loader
export const PulsingLogoLoader = ({ logoSrc = "/your-logo.svg" }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full bg-gray-900">
      <motion.div
        animate={{ scale: [1, 1.1, 1] }}
        transition={{ duration: 1.5, repeat: Infinity }}
        className="mb-6"
      >
        <img src={logoSrc} alt="Site Logo" className="w-24 h-24" />
      </motion.div>
      <motion.p
        animate={{ opacity: [1, 0.6, 1] }}
        transition={{ duration: 1.5, repeat: Infinity }}
        className="text-white text-lg font-medium"
      >
        Loading game...
      </motion.p>
    </div>
  );
};

// Progress Bar Loader
export const ProgressBarLoader = ({ logoSrc = "/your-logo.svg" }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full bg-gray-900">
      <img src={logoSrc} alt="Site Logo" className="w-24 h-24 mb-6" />
      <div className="w-64 h-2 bg-gray-700 rounded-full overflow-hidden mb-3">
        <motion.div
          className="h-full bg-green-500 rounded-full"
          initial={{ width: "0%" }}
          animate={{ width: "100%" }}
          transition={{ duration: 2, repeat: Infinity }}
        />
      </div>
      <p className="text-white text-lg font-medium">Loading game...</p>
    </div>
  );
};

// Cards Shuffle Loader
export const CardsShuffleLoader = ({ logoSrc = "/your-logo.svg" }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full bg-gray-900">
      <div className="relative h-24 w-36 mb-8">
        <img
          src={logoSrc}
          alt="Site Logo"
          className="absolute top-0 left-0 right-0 mx-auto z-10 w-12 h-12"
        />

        <motion.div
          className="absolute w-12 h-16 bg-white rounded-md shadow-md flex items-center justify-center"
          style={{ left: "30%" }}
          animate={{
            rotateY: [0, 180, 0],
            x: [0, -30, 0],
            zIndex: [1, 3, 1],
          }}
          transition={{ duration: 2, repeat: Infinity, delay: 0 }}
        >
          <span className="text-black text-2xl">♠</span>
        </motion.div>

        <motion.div
          className="absolute w-12 h-16 bg-white rounded-md shadow-md flex items-center justify-center"
          style={{ left: "50%" }}
          animate={{
            rotateY: [0, 180, 0],
            x: [0, 30, 0],
            zIndex: [2, 1, 2],
          }}
          transition={{ duration: 2, repeat: Infinity, delay: 0.5 }}
        >
          <span className="text-red-600 text-2xl">♥</span>
        </motion.div>
      </div>
      <p className="text-white text-lg font-medium">Shuffling the deck...</p>
    </div>
  );
};

// Dice Roll Loader
export const DiceRollLoader = ({ logoSrc = "/your-logo.svg" }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full bg-gray-900">
      <div className="flex items-center justify-center mb-6">
        <img src={logoSrc} alt="Site Logo" className="w-16 h-16 mr-6" />
        <motion.div
          className="w-16 h-16 bg-white rounded-lg shadow-lg flex items-center justify-center text-3xl font-bold"
          animate={{
            rotateX: [0, 360],
            rotateY: [0, 360],
          }}
          transition={{ duration: 1.5, repeat: Infinity }}
        >
          <motion.span
            animate={{ opacity: [1, 0, 1], scale: [1, 0.8, 1] }}
            transition={{ duration: 1.5, repeat: Infinity }}
          >
            7
          </motion.span>
        </motion.div>
      </div>
      <p className="text-white text-lg font-medium">Rolling the dice...</p>
    </div>
  );
};

// // Export a default component that showcases all loaders
// const LoaderShowcase = ({ logoSrc = "/your-logo.svg", type = "spinner" }) => {
//   switch (type.toLowerCase()) {
//     case "pulse":
//       return <PulsingLogoLoader logoSrc={logoSrc} />;
//     case "progress":
//       return <ProgressBarLoader logoSrc={logoSrc} />;
//     case "cards":
//       return <CardsShuffleLoader logoSrc={logoSrc} />;
//     case "dice":
//       return <DiceRollLoader logoSrc={logoSrc} />;
//     case "spinner":
//     default:
//       return <LogoSpinnerLoader logoSrc={logoSrc} />;
//   }
// };

// export default LoaderShowcase;
